import { Component, computed, inject, input } from '@angular/core';
import { CrntButtonAlt, CrntIcon } from '@essent/current-web-angular';
import { JssPlatformService } from '@core/jss-platform';
import {
  JssModule,
  LinkField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { ContentSectionService } from '@core/content-section';
import { NgClass } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackLinkDirective } from '@analytics/events';

export type Step = {
  icon: string;
  explanation: TextField;
};

@Component({
  selector: 'wl-steps',
  standalone: true,
  imports: [
    JssModule,
    CrntButtonAlt,
    CrntIcon,
    GenericLinkDirective,
    RichTextWrapperComponent,
    NgClass,
    AutomationIdDirective,
    TrackLinkDirective,
  ],
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.ed.scss', './steps.component.essent.scss'],
})
export class StepsComponent {
  readonly theme = inject(ContentSectionService).theme;
  readonly #jssPlatformService = inject(JssPlatformService);
  readonly #fieldService = inject(FieldService);

  readonly headingField = input.required<TextField>();
  readonly button = input.required<LinkField>();

  readonly steps = input.required<Step[]>();

  readonly isButtonInverted = computed(
    () => this.theme() === 'Donker' || this.theme() === 'Merk'
  );

  readonly showButton = computed(() =>
    this.#fieldService.showLinkField(this.button())
  );

  readonly isEditorActive = computed(() =>
    this.#jssPlatformService.isEditorActive()
  );
}
